import React from "react";
import { Typography } from "@material-ui/core";
import withIntl from "../../utils/withIntl";

const types = { POS80: { type: "POS80", sub_type: "POS80" }, STAR: { type: "STAR", sub_type: "STAR" } };

function PrinterType(props) {
  const printer = props.printer;

  switch (printer.type) {
    case "POS80":
      return <Typography>POS80</Typography>;
    case "STAR":
      return <Typography>STAR</Typography>;
    case "EPSON":
      return <Typography>EPSON</Typography>;
  }
  return <Typography>UNKNOWN PRINTER TYPE</Typography>;
}

export default withIntl(PrinterType);
